module.exports = __webpack_public_path__ + "img/4-7.4c089af8.png";